import { Route, Switch } from 'react-router-dom';
import { CentralPublishPage } from 'src/ui/features/central/pages/CentralPublishPage';
import { centralPaths } from './paths/central.paths';

export const CentralRouter = () => (
    <Switch>
        <Route path={centralPaths.publish} component={CentralPublishPage} />
    </Switch>
);
